<template>
  <v-switch dense
            class="pa-0 mt-2 mr-2"
            label="Item entregue"
            color="primary"
            :disabled="entregue || !hasRoleGestorEntrega"
            v-model="entregue"
            @change="onChangeEntrega"/>
</template>

<script>
import CompraProdutoService from '@/modules/compra/compra-produto-service';
import { SituacaoEntregaCompra } from 'px-business-components';
import { mapGetters } from 'vuex';

export default {
  props: {
    compraProduto: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorEntrega']),
  },
  data() {
    return {
      entregue: null,
    };
  },
  methods: {
    onChangeEntrega() {
      CompraProdutoService.finalizarEntregaProduto(this.compraProduto.compra.id,
        this.compraProduto.id).then(() => {
        this.$emit('change');
        this.$toast('Compra atualizada', { color: 'success' });
      });
    },
  },
  created() {
    this.entregue = this.compraProduto.situacaoEntrega === SituacaoEntregaCompra.keys.ENTREGUE.key;
  },
};
</script>
